var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('goodsGridEditor',{attrs:{"res":_vm.t_data,"show_price":false,"show_subtitle":false,"show_brand":false,"show_space":false,"show_style":false,"limit_num":_vm.limit_num},on:{"bindGoods":_vm.showGoods}}),_c('goodsPicker',{attrs:{"usage":"pc","visible":_vm.goodsVisible},on:{"pickGoods":_vm.pickGoods,"closeDialog":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }